import { render } from "./EmployeeAccessCustomer.vue?vue&type=template&id=4b11c96a&scoped=true"
import script from "./EmployeeAccessCustomer.vue?vue&type=script&lang=js"
export * from "./EmployeeAccessCustomer.vue?vue&type=script&lang=js"

import "./EmployeeAccessCustomer.vue?vue&type=style&index=0&id=4b11c96a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b11c96a"],['__file',"src/views/h5/common/basedata/employee/employeeDataAccess/EmployeeAccessCustomer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b11c96a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b11c96a', __exports__)) {
    api.reload('4b11c96a', __exports__)
  }
  
  module.hot.accept("./EmployeeAccessCustomer.vue?vue&type=template&id=4b11c96a&scoped=true", () => {
    api.rerender('4b11c96a', render)
  })

}


export default __exports__